package top.wcpe.allincore.ui.runtime.reactive

import top.wcpe.allincore.ui.runtime.internal.concurrent.newIdentitySet

/**
 * 派生信号：懒求值，并对下游可追踪。
 *
 * 依赖变化时仅标记 dirty，下一次 [get] 才重新求值；同时作为 [Trackable]
 * 注册给外层追踪器，实现 Computed 嵌套 Computed 的链式追踪。
 */
class Computed<T>(private val supplier: () -> T) :
    Trackable,
    Subscriber {

    private var cached: T? = null
    private var dirty: Boolean = true
    private var deps: MutableSet<Trackable> = newIdentitySet()
    private val subscribers: MutableSet<Subscriber> = newIdentitySet()

    /** 读取当前值：若 dirty 则重算并缓存；同时把自身注册给外层追踪器以支持链式追踪。 */
    fun get(): T? {
        ReactiveContext.track(this)
        if (dirty) recompute()
        return cached
    }

    private fun recompute() {
        for (t in deps) t.unsubscribe(this)
        deps.clear()
        val collected: MutableSet<Trackable> = newIdentitySet()
        ReactiveContext.pushTracker(ReactiveContext.Frame(this, collected))
        try {
            cached = supplier()
        } finally {
            ReactiveContext.popTracker()
        }
        deps = collected
        dirty = false
    }

    override fun onChange() {
        if (dirty) return
        dirty = true
        val snapshot = ArrayList(subscribers)
        for (s in snapshot) s.onChange()
    }

    override fun subscribe(subscriber: Subscriber) {
        subscribers.add(subscriber)
    }
    override fun unsubscribe(subscriber: Subscriber) {
        subscribers.remove(subscriber)
    }
}
